import { careerData } from '../../data/careerData'
import CardSection from '../shared/CardSection'
import { FaBriefcase } from 'react-icons/fa'

const Career = () => (
  <CardSection
    id="careers"
    title="My Career"
    icon={<FaBriefcase />}
    data={careerData}
    fields={['company', 'position', 'duration']}
  />
)

export default Career
